<div class="mde-editor-container" [attr.data-testid]="'mde-editor-container'">
  <!-- Mobile Notice -->
  @if (isMobile()) {
  <div class="mde-mobile-notice" [attr.data-testid]="'mde-mobile-notice'">
    <p>{{ 'formBuilder.mdeEditorMobileNotice' | translate }}</p>
  </div>
  }

  <!-- Editor Error Fallback -->
  @if (editorError()) {
  <div class="mde-editor-fallback" [attr.data-testid]="'mde-editor-fallback'">
    <textarea class="textarea-fallback" [value]="value()" (change)="onFallbackChange($event)"
      [placeholder]="placeholder()" data-testid="mde-textarea-fallback"></textarea>
  </div>
  }

  <!-- EasyMDE Editor -->
  @if (!editorError()) {
  <div class="mde-wrapper" [attr.data-testid]="'mde-wrapper'">
    <textarea #editorElement class="mde-textarea" [placeholder]="placeholder()" data-testid="mde-textarea"></textarea>
  </div>

  <!-- Vertical Preview Below -->
  @if (showVerticalPreview()) {
  <div class="vertical-preview" [attr.data-testid]="'vertical-preview'">
    <div class="vertical-preview-content" [innerHTML]="previewMarkdown() | markdown"></div>
  </div>
  }
  }

  @if (showMetadataHelp()) {
  <app-metadata-help-dialog (closed)="showMetadataHelp.set(false)" />
  }
</div>